module.exports = __webpack_public_path__ + "ff90cd8d32e61337d542bf3c07d640aa.svg";